<div class="p-4 space-y-3 flex flex-col h-full">

  <div class="flex items-center gap-3 flex-wrap">
    <h2 class="text-sm font-semibold text-gray-900 dark:text-white flex items-center gap-2">
      <i class="fa-solid fa-database text-app-teal-100"></i>
      MongoDB <span class="text-app-teal-100">{{ stack | uppercase }}</span>
    </h2>

    <!-- Database picker — typeahead search w/ substring-match highlight
         so the many `<name>_LIVE-yyyy-mm-dd` dbs are actually findable. -->
    <div class="text-xs text-gray-500 dark:text-gray-400 flex items-center gap-2">
      <span>db:</span>
      <app-search-combobox
        [items]="databaseNames"
        [value]="selectedDb"
        [placeholder]="'search databases…'"
        [disabled]="loading || databaseNames.length === 0"
        [minWidth]="'260px'"
        (valueChange)="onDbChange($event)">
      </app-search-combobox>
    </div>

    <!-- Collection picker — same typeahead treatment. -->
    <div class="text-xs text-gray-500 dark:text-gray-400 flex items-center gap-2">
      <span>collection:</span>
      <app-search-combobox
        #colCombobox
        [items]="collections"
        [value]="selectedCol"
        [placeholder]="'search collections…'"
        [disabled]="loading || collections.length === 0"
        [minWidth]="'260px'"
        (valueChange)="onColChange($event)">
      </app-search-combobox>
    </div>

    <button class="dark-btn dark-btn-sm" (click)="loadFirstPageAndWireDatasource()" [disabled]="loading || !selectedDb || !selectedCol">
      <i class="fa-solid fa-rotate-right mr-1" [class.fa-spin]="loading"></i>Reload
    </button>

    <app-grid-copy-menu *ngIf="selectedDb && selectedCol" [gridApi]="grid?.api"></app-grid-copy-menu>
    <app-copy-source-button *ngIf="selectedDb && selectedCol"
      [source]="stack + ':' + selectedDb + '.' + selectedCol"
      [tooltip]="'Mongo path on the ' + (stack | uppercase) + ' stack'">
    </app-copy-source-button>

    <span *ngIf="selectedDb && selectedCol" class="text-xs text-gray-500 dark:text-gray-400 ml-2">
      <strong>{{ (totalCount ?? 0) | number }}</strong> row<span *ngIf="totalCount !== 1">s</span> total<span *ngIf="totalCount === null" class="opacity-60"> (loading…)</span>
      <span *ngIf="columnDefs.length > 0" class="ml-1">
        · <strong>{{ columnDefs.length }}</strong> field<span *ngIf="columnDefs.length !== 1">s</span>
      </span>
      <span *ngIf="loadedAt" class="ml-2">
        · loaded {{ loadedAt | date:'MMM d, y, h:mm:ss a' }}
      </span>
    </span>
  </div>

  <p class="text-xs text-gray-500 dark:text-gray-400">
    Read/write view of the
    <code class="text-app-teal-100">{{ stack === 'v1' ? '.90/.52 (legacy)' : '.133 (current)' }}</code>
    Mongo stack. Columns are derived per collection — producer-side
    field additions surface on the next Reload without a UI change.
    Cells are editable except <code>_id</code> / <code>__v</code>; every
    edit prompts a confirm dialog and writes a single-field
    <code>$set</code> patch (plus a <code>_explorer_updated_at</code>
    timestamp for audit).
  </p>

  <div *ngIf="!selectedDb || !selectedCol"
       class="flex-1 flex items-center justify-center text-sm text-gray-500 dark:text-gray-400 border border-dashed border-gray-300 dark:border-[#434863] rounded">
    <div class="text-center space-y-1">
      <div><i class="fa-solid fa-arrow-up mr-1"></i> Pick a database and collection to view.</div>
      <div class="text-[11px]">
        Wildcards work: pick the <code class="text-app-teal-100">Massive</code> DB
        to browse any of its collections.
      </div>
    </div>
  </div>

  <!-- Infinite row model — no [rowData] binding; the grid pulls blocks
       from the datasource we wire up on col change (loadFirstPageAnd
       WireDatasource). Filter/sort changes reset the cache and trigger
       fresh datasource pulls automatically. -->
  <ag-grid-angular
    *ngIf="selectedDb && selectedCol"
    class="w-full flex-1 min-h-[520px]"
    [gridOptions]="grid.options"
    [columnDefs]="columnDefs"
    [theme]="theme">
  </ag-grid-angular>
</div>
